module.exports = __webpack_public_path__ + "img/tian.8642aeb9.png";